import React from "react";

import cn from "classnames";

import { box, Box } from "../../../../../helpers/common/Box/Box";
import { Avatar } from "../../../Avatar";

import type { BoxComponentWithDefault } from "../../../../../helpers/common/Box/Box";
import type { OmitOfUnion } from "../../../../../types/react";
import type { AvatarProps } from "../../../Avatar";
import type { AvatarsViewSize } from "../../types";

import classes from "../../AvatarsView.styl";

const AVATARS_VIEW_AVATAR_TEST_ID = "avatars-view-avatar-test-id";

type ConstantAvatarsViewAvatar = "size";
export type AvatarsViewAvatarProps = OmitOfUnion<
    AvatarProps<AvatarsViewSize>,
    ConstantAvatarsViewAvatar
>;

const AvatarsViewAvatar = box<
    BoxComponentWithDefault<typeof Avatar, unknown, ConstantAvatarsViewAvatar>
>(({ as = Avatar, ...props }) => {
    const boxProps = props as unknown as AvatarProps<AvatarsViewSize>;
    const avatarWrapperClasses = cn(
        classes["avatar-wrapper"],
        classes[`__size-${boxProps.size!}`],
    );

    return (
        <div className={avatarWrapperClasses}>
            <Box
                as={as}
                data-tsid={AVATARS_VIEW_AVATAR_TEST_ID}
                {...boxProps}
            />
        </div>
    );
});

AvatarsViewAvatar.displayName = "AvatarsView.Avatar";

export default AvatarsViewAvatar;
